import { useCallback, useEffect, useRef, useState } from 'react';

import { v4 as uuid } from 'uuid';

const useInterval = (callback, delay) => {
	const savedCallback = useRef() as any;

	const [id, setId] = useState(uuid());
	savedCallback.current = callback;

	useEffect(() => {
		function tick() {
			savedCallback.current();
		}

		if (delay !== null) {
			const id = setInterval(tick, delay);
			return () => clearInterval(id);
		}
	}, [delay, id]);

	const reset = useCallback(() => {
		setId(uuid());
	}, []);

	return reset;
};

export default useInterval;
